const ENV_CONFIGURATIONS = {
  BASE_URL: process.env.REACT_APP_BASE_URL,
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  FORM_NAVIGATION_CLIENT: process.env.REACT_APP_FORM_NAVIGATION_CLIENT_URL,
  FORM_NAVIGATION_STAFF: process.env.REACT_APP_FORM_NAVIGATION_STAFF_URL,
};

export const CONFIGURATIONS = ENV_CONFIGURATIONS;
